import React, { useState } from "react";
import { AuthProvider } from "@/context/AuthContext";
import { NotificationProvider } from "@/context/NotificationContext";
import { ProtectedRoute } from "@/components/guards/ProtectedRoute";
import { Layout } from "@/components/common/Layout";
import { NavTab } from "@/components/common/Sidebar";
import { DashboardOverview } from "@/features/dashboard/DashboardOverview";
import { ApplicationsList } from "@/features/applications/ApplicationsList";
import { UsersList } from "@/features/users/UsersList";
import { RolesList } from "@/features/roles/RolesList";
import { AuditLogsList } from "@/features/audit/AuditLogsList";

export const AppContent: React.FC = () => {
  const [activeTab, setActiveTab] = useState<NavTab>("dashboard");

  return (
    <ProtectedRoute>
      <Layout activeTab={activeTab} onSelectTab={setActiveTab}>
        {activeTab === "dashboard" && <DashboardOverview onNavigate={setActiveTab} />}
        {activeTab === "applications" && <ApplicationsList />}
        {activeTab === "users" && <UsersList />}
        {activeTab === "roles" && <RolesList />}
        {activeTab === "audit" && <AuditLogsList />}
      </Layout>
    </ProtectedRoute>
  );
};

export const App: React.FC = () => {
  return (
    <AuthProvider>
      <NotificationProvider>
        <AppContent />
      </NotificationProvider>
    </AuthProvider>
  );
};

export default App;
